import { GraphQLFormattedError } from 'graphql'
import { client } from '../..'
import { Country, SetCutoffDayForCountryMutation, SetCutoffDayForCountryMutationVariables } from '../../types'
import { SET_CUTOFF_DAY_FOR_COUNTRY } from './Mutations'
import { GET_COUNTRY_SETTINGS } from './Queries'

export const setCutoffDayForCountry = async (
  country: Country,
  cutoffDay: number,
): Promise<{
  data: SetCutoffDayForCountryMutation | null | undefined
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: readonly GraphQLFormattedError<Record<string, any>>[] | undefined
}> => {
  const { data, errors } = await client.mutate<SetCutoffDayForCountryMutation, SetCutoffDayForCountryMutationVariables>({
    mutation: SET_CUTOFF_DAY_FOR_COUNTRY,
    variables: {
      country,
      cutoffDay,
    },
    refetchQueries: [
      {
        query: GET_COUNTRY_SETTINGS,
        variables: {
          country,
        },
      },
    ],
  })
  return { data, errors }
}
